export default __webpack_public_path__ + "static/media/Engage_Connect_App_Icon.978db560.svg";